const t = (e) => ({ entityId: a, batchId: i }) => e.get(
  `/v2/matav-chains-union/${i}/${a}`,
  {}
), s = (e) => () => e.get("/premium-layer-permissions", {});
export {
  t as getChainTilesTTAMetadata,
  s as getPremiumLayerPermissions
};
//# sourceMappingURL=index.es494.js.map
